/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M8 14V16M8 19V21M16 14V16M16 19V21M12 15V17M12 20V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M12 2C7.74741 2 4.3 5.55187 4.3 9.93333C4.3 9.98093 4.30041 10.0284 4.30122 10.0758C2.40285 10.5786 1 12.3539 1 14.4667C1 16.9704 2.96995 19 5.4 19H17.5C20.5376 19 23 16.4629 23 13.3333C23 10.9231 21.5395 8.86433 19.4806 8.0452C18.6584 4.5753 15.6211 2 12 2Z"
				fill="currentColor"
			/>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M8 14V16M8 19V21M16 14V16M16 19V21M12 15V17M12 20V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 1.25C7.4446 1.25 3.76319 4.9413 3.55893 9.53106C1.61442 10.2944 0.25 12.225 0.25 14.4667C0.25 16.9258 1.89666 19.0173 4.14719 19.5931C4.39026 19.6553 4.5118 19.6864 4.64581 19.6455C4.75193 19.6132 4.86956 19.5218 4.92721 19.427C5 19.3074 5 19.1613 5 18.8692V13.1212C5 12.4011 5 12.041 5.14996 11.799C5.28132 11.587 5.48715 11.4318 5.72708 11.3637C6.00097 11.286 6.34717 11.3849 7.03955 11.5827L10.2418 12.4977L10.2418 12.4977C10.8959 12.6845 11.223 12.778 11.5556 12.8152C11.851 12.8482 12.149 12.8482 12.4444 12.8152C12.777 12.778 13.1041 12.6845 13.7582 12.4977L16.9604 11.5827L16.9605 11.5827C17.6528 11.3849 17.999 11.286 18.2729 11.3637C18.5128 11.4318 18.7187 11.587 18.85 11.799C19 12.041 19 12.4011 19 13.1212V18.5375C19 18.8758 19 19.045 19.0862 19.1721C19.155 19.2735 19.2899 19.3613 19.4105 19.3833C19.5616 19.4108 19.6977 19.3506 19.97 19.2303C22.2009 18.2444 23.75 15.9641 23.75 13.3333C23.75 10.7563 22.268 8.52279 20.1145 7.50352C19.095 3.90344 15.8601 1.25 12 1.25ZM8.75 14C8.75 13.5858 8.41421 13.25 8 13.25C7.58579 13.25 7.25 13.5858 7.25 14V16C7.25 16.4142 7.58579 16.75 8 16.75C8.41421 16.75 8.75 16.4142 8.75 16V14ZM16.75 14C16.75 13.5858 16.4142 13.25 16 13.25C15.5858 13.25 15.25 13.5858 15.25 14V16C15.25 16.4142 15.5858 16.75 16 16.75C16.4142 16.75 16.75 16.4142 16.75 16V14ZM12.75 15C12.75 14.5858 12.4142 14.25 12 14.25C11.5858 14.25 11.25 14.5858 11.25 15V17C11.25 17.4142 11.5858 17.75 12 17.75C12.4142 17.75 12.75 17.4142 12.75 17V15ZM8.75 19C8.75 18.5858 8.41421 18.25 8 18.25C7.58579 18.25 7.25 18.5858 7.25 19V21C7.25 21.4142 7.58579 21.75 8 21.75C8.41421 21.75 8.75 21.4142 8.75 21V19ZM16.75 19C16.75 18.5858 16.4142 18.25 16 18.25C15.5858 18.25 15.25 18.5858 15.25 19V21C15.25 21.4142 15.5858 21.75 16 21.75C16.4142 21.75 16.75 21.4142 16.75 21V19ZM12.75 20C12.75 19.5858 12.4142 19.25 12 19.25C11.5858 19.25 11.25 19.5858 11.25 20V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V20Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C13.9084 2 15.6547 2.69815 17 3.85431M8 14V16M8 19V21M16 14V16M16 19V21M12 15V17M12 20V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M3.2 18C1.88484 17.235 1 15.8051 1 14.1674C1 12.1053 2.40285 10.3727 4.30122 9.88197C4.30041 9.83571 4.3 9.78935 4.3 9.7429C4.3 5.46661 7.74741 2 12 2C15.6211 2 18.6584 4.51348 19.4806 7.90009C21.5395 8.69955 23 10.7089 23 13.0613C23 14.8707 22.1359 16.4772 20.8 17.4862M8 14V16M8 19V21M16 14V16M16 19V21M12 15V17M12 20V22"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M3.55893 9.53106C3.76319 4.9413 7.4446 1.25 12 1.25C15.8601 1.25 19.095 3.90344 20.1145 7.50352C22.268 8.52279 23.75 10.7563 23.75 13.3333C23.75 15.9641 22.2009 18.2444 19.97 19.2303C19.6977 19.3506 19.5616 19.4108 19.4105 19.3833C19.2899 19.3613 19.155 19.2735 19.0862 19.1721C19 19.045 19 18.8758 19 18.5375V13.1212C19 12.4011 19 12.041 18.85 11.799C18.7187 11.587 18.5128 11.4318 18.2729 11.3637C17.999 11.286 17.6528 11.3849 16.9604 11.5827L13.7582 12.4977C13.1041 12.6845 12.777 12.778 12.4444 12.8152C12.149 12.8482 11.851 12.8482 11.5556 12.8152C11.223 12.778 10.8959 12.6845 10.2418 12.4977L7.03955 11.5827C6.34717 11.3849 6.00097 11.286 5.72708 11.3637C5.48715 11.4318 5.28132 11.587 5.14996 11.799C5 12.041 5 12.4011 5 13.1212V18.8692C5 19.1613 5 19.3074 4.92721 19.427C4.86956 19.5218 4.75193 19.6132 4.64581 19.6455C4.5118 19.6864 4.39026 19.6553 4.14719 19.5931C1.89666 19.0173 0.25 16.9258 0.25 14.4667C0.25 12.225 1.61442 10.2944 3.55893 9.53106Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 13.25C8.41421 13.25 8.75 13.5858 8.75 14V16C8.75 16.4142 8.41421 16.75 8 16.75C7.58579 16.75 7.25 16.4142 7.25 16V14C7.25 13.5858 7.58579 13.25 8 13.25ZM16 13.25C16.4142 13.25 16.75 13.5858 16.75 14V16C16.75 16.4142 16.4142 16.75 16 16.75C15.5858 16.75 15.25 16.4142 15.25 16V14C15.25 13.5858 15.5858 13.25 16 13.25ZM12 14.25C12.4142 14.25 12.75 14.5858 12.75 15V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V15C11.25 14.5858 11.5858 14.25 12 14.25ZM8 18.25C8.41421 18.25 8.75 18.5858 8.75 19V21C8.75 21.4142 8.41421 21.75 8 21.75C7.58579 21.75 7.25 21.4142 7.25 21V19C7.25 18.5858 7.58579 18.25 8 18.25ZM16 18.25C16.4142 18.25 16.75 18.5858 16.75 19V21C16.75 21.4142 16.4142 21.75 16 21.75C15.5858 21.75 15.25 21.4142 15.25 21V19C15.25 18.5858 15.5858 18.25 16 18.25ZM12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
